/* MC Animations — 0 dépendance, ~1,4 Ko.
   1) duplique le contenu des bandeaux pour une boucle sans couture
   2) révèle les cartes au scroll via IntersectionObserver
   3) confirme visuellement l'ajout au panier
   Ne fait rien si l'utilisateur a demandé moins d'animations. */
(function () {
  'use strict';

  var reduced = window.matchMedia &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. BANDEAUX DÉFILANTS ---------- */
  function marquee() {
    var bands = document.querySelectorAll('.band:not([data-mc-marquee])');
    for (var i = 0; i < bands.length; i++) {
      var b = bands[i];
      b.setAttribute('data-mc-marquee', '1');
      if (reduced) continue;

      var text = b.innerHTML.trim();
      if (!text) continue;

      var track = document.createElement('div');
      track.className = 'band-track';
      var a = document.createElement('span'); a.innerHTML = text;
      track.appendChild(a);

      b.innerHTML = '';
      b.appendChild(track);

      /* Un seul segment plus etroit que l'ecran laisse un trou pendant le
         defilement. On duplique jusqu'a couvrir 2x la largeur visible, puis
         on anime sur la moitie exacte : la boucle est sans couture. */
      var seg = a.offsetWidth || 600;
      var need = b.offsetWidth || 1200;
      var copies = Math.max(2, Math.ceil((need * 2) / seg));
      if (copies % 2) copies++;            // toujours pair : moitie exacte
      for (var k = 1; k < copies; k++) {
        var c = a.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');  // pas relu par les lecteurs d'ecran
        track.appendChild(c);
      }
      var dist = seg * (copies / 2);
      /* vitesse proportionnelle a la distance : defilement constant */
      track.style.animationDuration = Math.max(14, Math.round(dist / 40)) + 's';
    }
  }

  /* ---------- 2. APPARITION AU SCROLL ---------- */
  function reveal() {
    if (reduced || !('IntersectionObserver' in window)) return;

    var groups = [
      ['.mc-grid .card', 5],
      ['.mcb-card', 4],
      ['.mc-cats .mc-cat', 5],
      ['.fr-card', 4],
      ['.mc-branch', 3],
      ['.sec-title', 0],
      ['.sec-sub', 0]
    ];

    var targets = [];
    groups.forEach(function (g) {
      var els = document.querySelectorAll(g[0]);
      for (var i = 0; i < els.length; i++) {
        if (els[i].hasAttribute('data-mc-rise')) continue;
        els[i].setAttribute('data-mc-rise', '1');
        els[i].classList.add('mc-rise');
        if (g[1]) els[i].setAttribute('data-d', String((i % g[1]) + 1));
        targets.push(els[i]);
      }
    });
    if (!targets.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    targets.forEach(function (t) { io.observe(t); });

    /* sécurité : si quelque chose cloche, tout devient visible après 2,5 s */
    setTimeout(function () {
      targets.forEach(function (t) { t.classList.add('is-in'); });
    }, 2500);
  }

  /* ---------- 3. RETOUR VISUEL SUR L'AJOUT AU PANIER ---------- */
  function feedback() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest && ev.target.closest('.card-add');
      if (!btn || reduced) return;
      btn.classList.remove('is-added');
      void btn.offsetWidth;              // force le redémarrage de l'animation
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 900);

      var bubble = document.querySelector('.cart-bubble, [class*="cart-count"]');
      if (bubble) {
        bubble.classList.remove('is-bump');
        void bubble.offsetWidth;
        bubble.classList.add('is-bump');
        setTimeout(function () { bubble.classList.remove('is-bump'); }, 500);
      }
    }, true);
  }

  function init() { marquee(); reveal(); feedback(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Horizon recharge des sections en AJAX : on réarme après coup */
  document.addEventListener('shopify:section:load', init);
})();
